import {StyleSheet} from 'react-native';

import {cloudLight, onyx, white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  header: {
    paddingVertical: 20,
    backgroundColor: white,
  },
  section: {
    flex: 1,
    backgroundColor: white,
    marginTop: 20,
  },
  listItemLabel: {
    paddingLeft: 20,
  },
  listItemLabelText: {
    marginBottom: 4,
    fontSize: 16,
  },
  listItemTextColor: {
    color: onyx,
  },
  listItemSuffix: {
    paddingRight: 20,
  },
  divider: {
    height: 1,
    backgroundColor: cloudLight,
    marginHorizontal: 20,
  },
});
